import { createContext } from "react";
import type { WithdrawCurrencyId } from "./types";

export type WithdrawWizardContextState = {
  amount: number;
  setAmount: (amount: number) => void;

  // the account's currency, which selects the flow
  currency: WithdrawCurrencyId;

  // resolved once by the wizard so each view shares one reading of it
  withdrawableAmountInCents: number;

  // NZD only. Held here rather than in the view because the picker step
  // unmounts the view that submits it. Undefined until the user picks, so
  // the view falls back to the first known email.
  skrillEmail?: string;
  setSkrillEmail: (email: string) => void;

  // CAD only, and hoisted for the same reason as skrillEmail. Holds the
  // wallet id rather than the address so a live Firestore update to the
  // address itself is always reflected.
  interacWalletId?: string;
  setInteracWalletId: (walletId: string) => void;

  // a withdrawal is in flight, so the wizard's inputs and every exit route are
  // held shut until an outcome screen is reached
  submitting: boolean;
  setSubmitting: (submitting: boolean) => void;

  // IOM users need to verify their identity before they can withdraw, they are
  // shown the verification screen after they submit the form
  mustVerifyToWithdraw: boolean;
  showVerificationRequired: () => void;

  // CAD users can reach the wizard to manage their Interac wallets before
  // they're allowed to withdraw, they are shown why once they submit the form
  canWithdraw: boolean;
  showWithdrawUnavailable: () => void;
  canManageWallets: boolean;

  // closes the modal hosting the wizard
  close: () => void;
};

export const WithdrawWizardContext =
  createContext<WithdrawWizardContextState | null>(null);
